<template>
    <div class="debugResult" >
        <div class="noDataPage" v-show="isInitDebugResult">
            <div class="noDataPageContent">
                <img src="../../../static/nodata.png" alt="#">
                <div class="noDebugResult" >{{$t('debug.noDebugResult')}}</div>
                <div class="info">{{$t('debug.debugTip1')}}</div>
                <el-button type="primary" style="width:82px;font-size:12px" size="mini" @click="launchDebug">{{$t('debug.beginDebug')}}</el-button>
            </div>
        </div>
        <div v-show="!isInitDebugResult">
            <div>
                <div class="title" style="height:18px">{{$t('debug.overView')}}</div>
                <div class="result">
                    <ul style="display:flex;">
                        <li class="resultStyle" :class="{enResultStyle: lang === 'en'}" v-if="debugResult.code">
                            <el-tag type="success" v-if="debugResult.code === 200 ">！{{$t('debug.debugSuccess')}}</el-tag>
                            <el-tag type="danger" v-else >！{{$t('debug.debugFailed')}}</el-tag>
                        </li>
                        <li class="resultStyle" :class="{enResultStyle: lang === 'en'}">{{$t('debug.consumeTime')}}：{{this.$store.state.debuggerTime}}ms</li>
                        <li class="resultStyle" :class="{enResultStyle: lang === 'en'}">{{$t('debug.statusCode')}}：{{this.$store.state.code}}</li>
                        <li class="resultStyle" :class="{enResultStyle: lang === 'en'}" style="border-right:none">{{$t('debug.requestType')}}：POST</li>
                    </ul>
                </div>
            </div>
            <div>
                <div class="title">{{$t('debug.realRequestUrl')}}</div>
                <div v-if="this.$store.state.vType === '2'">{{this.locationUrl +'/rest/api/v3' + enameUrl}}</div>
                <div v-else>{{this.locationUrl +'/rest/api'}}</div>
            </div>
            <div>
                <div class="title">{{$t('debug.requestData')}}</div>
                <div>
                    <template>
                        <el-tabs v-model="requestData" type="card" @tab-click="requestHandleClick">
                            <el-tab-pane :label="$t('debug.requestHeader')" name="first">
                                <div class="wrapper">
                                    <textarea id="requestTextareaContent" class="textareaStyle"  readonly="readonly">
                                        {{resquestHeadersData}}
                                    </textarea>
                                    <i @click="copyText('requestTextareaContent')" class="el-icon-copy-document copyIcon"></i>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('debug.requestData')" name="second">
                                <div class="wrapper">
                                    <textarea id="requestBodyTextareaContent" class="textareaStyle"  readonly="readonly">
                                        {{requestBodyData}}
                                    </textarea>
                                    <i @click="copyText('requestBodyTextareaContent')" class="el-icon-copy-document copyIcon"></i>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </template>
                </div>
            </div>
            <div>
                <div class="title">{{$t('debug.respondResult')}}</div>
                <div>
                    <template>
                        <el-tabs v-model="responseResults" type="card">
                            <el-tab-pane :label="$t('debug.respondHeader')" name="first">
                                <div class="wrapper">
                                    <textarea id="responseTextareaContent" class="textareaStyle"  readonly="readonly">
                                        {{responseHeader}}
                                    </textarea>
                                    <i @click="copyText('responseTextareaContent')" class="el-icon-copy-document copyIcon"></i>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('debug.respondBody')" name="second">
                                <div class="wrapper">
                                    <textarea id="responseBodyTextareaContent" class="textareaStyle"  readonly="readonly">
                                        {{debugResult}}
                                    </textarea>
                                    <i @click="copyText('responseBodyTextareaContent')" class="el-icon-copy-document copyIcon"></i>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex';
    export default {
        data() {
            var locationUrl = location.origin;
            return {
                requestData: 'second',
                responseResults: 'second',
                resquestHeadersData:{
                    "Connection": "keep-alive",
                    "Accept-Language": "zh-CN,zh;q=0.9",
                    "Cache-Control": "no-cache",
                    "Accept-Encoding": "gzip, deflate, br",
                    "Cache-Control": "no-cache"
                },
                locationUrl:locationUrl,
                lang: 'zh'
            }

        },
        computed: {
            ...mapState(['isInitDebugResult', 'debug', 'debugResult']),
            responseHeader() {
                return this.$store.state.responseData
            },
            requestBodyData() {
                return this.$store.state.debugParams
            },
            enameUrl() {
                return this.isUplodEname(this.$store.state.ename) ? '/file' : '' 
            }
        },
        watch: {
            debugResult: function() {
                document.getElementById('requestBodyTextareaContent').scrollTop = 0;
                document.getElementById('responseBodyTextareaContent').scrollTop = 0;
            }
        },
        mounted() {
        },
        created() {
            this.lang = localStorage.getItem('lang') || 'zh'
        },
        methods: {
            requestHandleClick() {},
            launchDebug(){
                this.$store.commit('setDebug', this.debug ? false : true);
            },  
            copyText(id) {
                document.getElementById(id).select();
                document.execCommand("copy");
                 this.$message({
                    message: this.$t('public.copySuccess'),
                    duration: 1500,
                    showClose: false,
                    type: 'success',
                    center:true
                })
            },
            isUplodEname(ename) {
                var enameArr = ['addIots','deleteDevices','addDevices','recoverIots'];
                return enameArr.indexOf(ename) > -1
            }
        }
    }
</script>

<style lang="less" scoped>
    .debugResult {
        font-size: 14px;
        padding: 0 20px;
        padding-top: 61px;
        height:calc(100vh - 61px);

        .title {
            font-size: 18px;
            font-weight: bold;
            padding: 13px 0;
        }

        .result {
            margin-left: -68px;

            .el-tag {
                border-radius: 10px;
                height: 24px;
                line-height: 24px;
                text-align: center;
            }

            .resultStyle {
                width: 120px;
                height: 20px;
                margin-left: 10px;
                line-height: 20px;
                text-align: center;
                border-right: 1px solid;
                list-style-type: none ;
            }
            .enResultStyle{
                width: 160px;
            }
        }
        .wrapper{
            position: relative;
            .copyIcon{
                position: absolute;
                top: 20px;right: 30px;
                font-size: 18px;
            }
            .copyIcon:hover{
                color: #409EFF;
            }
        }
        .textareaStyle {
            width:99%;
            font-size:14px;
            line-height:24px;
            height:calc((100vh - 489px)/2);
            font-family:Arial;
            min-height:50px ;
            border-color: rgba(118, 118, 118, 0.3);
            outline:none;
            background: rgba(239, 239, 239, 0.3);
            color: rgb(94, 93, 93);  
        }

        .noDataPage{
            width: 500px;
            height: 400px;
            margin: 250px auto;

            .noDataPageContent {
               display:flex;
               height:400px;
               flex-direction: column;
               justify-content:center;
               align-items:center
            }
            .noDebugResult {
                margin-top:15px;
                font-size:16px;
                color: #8a8e99;
            }
            .info {
                margin: 20px 0;
                color: #575d6c;
            }
        }
    }
</style>
<style>
    .el-message {
        min-width: 280px !important;
    }
</style>